import dayjs from 'dayjs';
import 'dayjs/locale/ko'; // 한국어 로케일
import relativeTime from 'dayjs/plugin/relativeTime'; // 상대 시간 플러그인 (방금 전, 1시간 전 등)
import localizedFormat from 'dayjs/plugin/localizedFormat'; // 지역별 포맷

const dayjsPlugin = {
  install(app) {
    // 기본 로케일을 한국어로 설정
    dayjs.locale('ko');
    
    // 플러그인 확장
    dayjs.extend(relativeTime);
    dayjs.extend(localizedFormat);

    /**
     * $date 함수
     * @param {string|Date|number} date - 날짜 데이터
     * @param {string} format - 출력 포맷 (기본: 'YYYY-MM-DD')
     * @returns {string} 포맷팅된 날짜 문자열
     */
    const $date = (date = new Date(), format = 'YYYY-MM-DD') => {
      return dayjs(date).format(format);
    };

    const $getDay = (date)=>{

      const weekDays = ['일요일', '월요일','화요일','수요일','목요일','금요일','토요일']

      const day= new Date(date);

      return weekDays[day.getDay()];

    }

    /**
     * $fromNow 함수 (상대 시간)
     * @param {string|Date|number} date - 과거 날짜 데이터
     * @returns {string} '방금 전', '3분 전' 등 상대 시간 문자열
     */
    const $fromNow = (date) => {
      return dayjs(date).fromNow();
    };

    // Vue 전역 프로퍼티 및 window 객체 등록
    app.config.globalProperties.$dayjs = dayjs;
    app.config.globalProperties.$date = $date;
    app.config.globalProperties.$fromNow = $fromNow;
    app.config.globalProperties.$getDay = $getDay;

    window.$dayjs = dayjs;
    window.$date = $date;
    window.$fromNow = $fromNow;
    window.$getDay = $getDay;
  }
};

export default dayjsPlugin;
